// @flow

// Libs
import _reduce from 'lodash/reduce'

export default function composeTraverse (paths: Array<any>, options: ?Object = {}): (value: any) => any {
  const defaultTo = (options != null && options.default != null) ? options.default : null

  return function traverse (maybeSource: ?Object): any {
    if (maybeSource == null) {
      return defaultTo
    }

    return _reduce(paths, (acc: any, path: string | Function): any => {
      if (acc != null) {
        try {
          const value = typeof path === 'function'
            ? path(acc)
            : acc[path]

          if (value != null) {
            return value
          }
        } catch (error) {
          console.warn('fc-utils/traverse failed')
          console.info('Path', path)
          console.info('Data', maybeSource)
        }
      }

      return defaultTo
    }, maybeSource)
  }
}
